import {
  SET_CURATION_FILTER,
  UNSET_CURATION_FILTER,
} from "curation/actions/filters";

export default function(state = {}, action) {
  switch (action.type) {
    case SET_CURATION_FILTER:
      return { ...state, ...action.payload };
    /* eslint-disable no-case-declarations */
    case UNSET_CURATION_FILTER:
      const { [action.payload]: _, ...rest } = state; // eslint-disable-line no-unused-vars
      return rest;
    default:
      return state;
  }
}
